export function loadImageData(imgSrc: string) {
  return loadImage(imgSrc).then(extractImageData);
}

export function loadImage(
  imgSrc: string,
  crossOrigin: string | null = 'anonymous',
) {
  return new Promise<HTMLImageElement>((resolve, reject) => {
    const image = new Image();
    image.onload = () => {
      resolve(image);
    };
    image.onerror = (e) => {
      reject(e);
    };
    image.crossOrigin = crossOrigin;
    image.src = imgSrc;
  });
}

export function loadImageBlob(file: File) {
  return new Promise<ArrayBuffer>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = () => {
      resolve(reader.result as ArrayBuffer);
    };
    reader.onerror = () => {
      reject();
    };
  });
}

/**
 * The image must already have been loaded
 *
 * @throws DOMException when the image's CORS setting does not allow us to call `getImageData()`
 */
export function extractImageData(img: HTMLImageElement) {
  const canvas = drawImageOnTempCanvas(img);
  return canvas.getContext('2d')!.getImageData(0, 0, img.width, img.height);
}

export function imageToDataUrl(img: HTMLImageElement) {
  const canvas = drawImageOnTempCanvas(img);
  return canvas.toDataURL();
}

export function displayImageWithCanvas(
  imageData: ImageData,
  canvas: HTMLCanvasElement,
) {
  const width = (canvas.width = imageData.width);
  const height = (canvas.height = imageData.height);

  const context = canvas.getContext('2d');
  if (!context) {
    throw new Error('This canvas is already using a non-2d context');
  }

  context.clearRect(0, 0, width, height);
  context.putImageData(imageData, 0, 0);
}

export function createTempCanvas() {
  // fix me if you change this code
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion -- fix me!
  return document.createElement('canvas') as HTMLCanvasElement;
}

function drawImageOnTempCanvas(img: HTMLImageElement) {
  const canvas = createTempCanvas();
  const context = canvas.getContext('2d')!;
  canvas.width = img.width;
  canvas.height = img.height;
  context.drawImage(img, 0, 0);
  return canvas;
}
